import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Paper, Avatar, ToggleButton, ToggleButtonGroup, CircularProgress, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import useApiManager from '../../utils/Api/apiManager';
import { useNavigate } from "react-router-dom";
import Drawer from '../../components/Deals/Details/Drawer';
import BasicDetails from '../../components/Deals/Details/BasicDetails/BasicDetails';
import FullDetails from '../../components/Deals/Details/FullDetails/FullDetails';
import Contacts from '../../components/Accounts/Details/Contacts/Contacts';
import HandshakeTwoToneIcon from '@mui/icons-material/HandshakeTwoTone';
import Notes from '../../components/Common/Notes/Notes';
import Attachments from '../../components/Common/Attachments/Attachments'
import StageHeader from '../../components/Deals/Details/StageHeader/StageHeader';
import StageHistory from '../../components/Deals/Details/StageHistory/StageHistory';

const DealDetails = () => {
    const { dealId } = useParams(); // Get accountID from URL
    const [dealDetails, setDealDetails] = useState(null);
    const [notes, setNotes] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [stageHistory, setStageHistory] = useState([]);
    const detailsRef = useRef(null);
    const notesRef = useRef(null);
    const attachmentsRef = useRef(null);
    const stageHistoryRef = useRef(null);
    const contactsRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const { get } = useApiManager();

    const scrollToSection = (ref) => {
        ref.current.scrollIntoView({ behavior: 'smooth' });
    };

    const fetchDealDetails = async () => {
        setLoading(true);

        try {
            const data = await get(`/deals/${dealId}`);
            setDealDetails(data);
            const dealName = data.dealName ?? '';
            document.title = `${dealName} (Deal) - iLead CRM`.trim() || 'Deal Details';
        } catch (error) {
            console.error('Error fetching deal details:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchNotes = async () => {
        setLoading(true);

        try {
            const notes = await get(`/deals/${dealId}/notes`);
            setNotes(notes);
        } catch (error) {
            console.error('Error fetching deal notes:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchAttachments = async () => {
        setLoading(true);

        try {
            const attachments = await get(`/deals/${dealId}/attachments`);
            setAttachments(attachments);
        } catch (error) {
            console.error('Error fetching deal attachments:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchDealStageHistory = async () => {
        setLoading(true);
        try {
            const data = await get(`/deals/${dealId}/stage-history`);
            setStageHistory(data);
        } catch (error) {
            console.error('Error fetching deal stage history:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDealDetails();
        fetchNotes();
        fetchAttachments();
        fetchDealStageHistory();
    }, []);

    return (
        <div style={{}}>
            <Paper elevation={0} sx={{
                p: 2
            }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px' }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <HandshakeTwoToneIcon />
                        {loading ? (
                            <CircularProgress />
                        ) : (
                            <Typography sx={{ fontWeight: 'bold', fontSize: '1.35rem' }}>
                            {dealDetails?.dealName}
                            </Typography>
                        )}
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1 }}>

                        <Link to={`/deals/edit/${dealId}`}>
                            <Button variant="outlined">Edit</Button>
                        </Link>
                    </Box>
                </Box>
            </Paper >
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Box id='drawer' sx={{ display: 'flex' }}>
                    <Drawer
                        scrollToSection={scrollToSection}
                        sections={{
                            detailsRef,
                            notesRef,
                            attachmentsRef,
                            stageHistoryRef
                        }} />
                </Box>
                <Box id='main' sx={{ flexGrow: 1, paddingTop: 3, paddingRight: 5 }}>
                    {/* <ToggleButtonGroup
                        color="primary"
                        exclusive
                        aria-label="Platform"
                        sx={{ marginBottom: 3 }}
                    >
                        <ToggleButton value="overview">Overview</ToggleButton>
                        <ToggleButton value="history">History</ToggleButton>
                    </ToggleButtonGroup> */}
                    <Box sx={{ '& > * > *': { marginBottom: 3 } }}>

                        <div id='overview'>
                            <div>
                               <StageHeader activeStep={dealDetails?.stage} dealDetails={dealDetails} />
                            </div>
                            <div>
                                {/* <BasicDetails data={leadDetails} /> */}
                                <BasicDetails data={dealDetails}/>
                            </div>
                           
                            <div ref={detailsRef}>
                                <FullDetails data={dealDetails} />
                            </div>
                            <div ref={notesRef}>
                                <Notes data={notes} fetchNotes={fetchNotes} entity={'deals'} />
                            </div>
                            <div ref={attachmentsRef}>
                                <Attachments data={attachments} fetchAttachments={fetchAttachments} entity={'deals'}/>
                            </div>
                            <div ref={stageHistoryRef}>
                                <StageHistory data={stageHistory} />
                            </div>
                            {/* <div ref={contactsRef}>
                                <Contacts data={accountContacts} />
                            </div> */}
                            
                        </div>
                        <div id='history'></div>
                    </Box>
                </Box>
            </Box>

        </div>
    )
};

export default DealDetails;